import { SvgIcon } from "components/utils/SvgIcon";
import React from "react";
import { Tooltip } from "react-tippy";

const FamilleRenderer = (props) => {

  const generateLogoColor = (equipement) => {
    switch (equipement.etat) {
      case 0:
        return "#000";
      case 1:
      case 2:
        return "#a5c946";
      case 3:
        return "#f18d2d";
      case 4:
        return "#f14a2d";
      case 5:
        return "#8da1a7";
    }
  }

  const generateLibelle = (equipement) => {
    switch (equipement.etat) {
      case 0:
        return "Inconnu";
      case 1:
        return "Disponible";
      case 2:
        return "Disponible avec alarme(s) mineure(s)";
      case 3:
        return "Dégradé";
      case 4:
        return "Indisponible";
      case 5:
        return "Hors exploitation";
    }
  }

  const tooltipTemplate = (data) => {
    return (
      <div>
        <span>{data.famille}</span>
        <br />
        <span style={{ color: generateLogoColor(data) }}>{generateLibelle(data)}</span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex' }}>
      <Tooltip
        title={props.data.famille}
        position="bottom"
        trigger="mouseenter"
        html={tooltipTemplate(props.data)}
      >
        <SvgIcon color={generateLogoColor(props.data)} name={'signal-stream'} size={'60px'} type={props.data.famille} style={{ display: 'flex' }} />
      </Tooltip>
    </div>
  )

}

export default FamilleRenderer;